import { ESaveTypeId } from '@components/routes/AdminPanel/KpiThresholdManagement/KpiThresholdsTechnology/enums';

export const SaveTypes = [
	{
		text: 'Save as new preset',
		id: ESaveTypeId.saveNew,
		disabled: false,
	},
	{
		text: 'Save changes to current preset',
		id: ESaveTypeId.saveEdited,
		disabled: true,
	},
];
